import React, {useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {FaReply} from  'react-icons/fa';
import {FaArchive} from  'react-icons/fa';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import 'bootstrap/dist/css/bootstrap.min.css';

import appSettings from "../../appSettings.json";
import './TicketDetail.css';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';
import TicketInfo from '../../components/TicketInfo/TicketInfo';
import OpenConfirmDialog from '../../components/OpenConfirmDialog/OpenConfirmDialog';
import useFetch from '../../shared/hooks/useFetch';
import isFilled from '../../shared/utilities/isFilled';

const TicketDetail = (props) => {
    const { user, usersSAT } = props
    const navigate = useNavigate();
    const {ticketId} = useParams();
    const[openConfirm, setOpenConfirm] = useState(false)
    const[renderView, setRenderView] = useState(false);
    
    /* Llamada API metodo getTicket */
    const getTicket = `${appSettings.BASE_URL.default}/ticket/get-detail?ticketId=${ticketId}`;

    const[dataTicket, setDataTicket] = useState("");
    const[messageTicket, setMessageTicket] = useState("");
    const[successTicket, setSuccessTicket] = useState(false);

    const {serviceResponse : serviceResponseGetT, error : errorGetT, loading : loadingGetT} = useFetch(getTicket, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'GET', "", renderView)

    useEffect(() => {
        if(!loadingGetT){
            setDataTicket(serviceResponseGetT.data)
            setMessageTicket(serviceResponseGetT.message)
            setSuccessTicket(serviceResponseGetT.success)
        }
    }, [loadingGetT, serviceResponseGetT, errorGetT, renderView])

    /* Llamada API metodo uptTicket */
    const uptTicket = `${appSettings.BASE_URL.default}/ticket/upsert`;

    const[dataUptTicket, setDataUptTicket] = useState("")
    const[messageUptTicket, setMessageUptTicket] = useState("");
    const[successUptTicket, setSuccessUptTicket] = useState(false);

    const [bodyUptTicket, setBodyUptTicket] = useState();
    const {serviceResponse : serviceResponseUptT, error : errorUptT, loading : loadingUptT} = useFetch(uptTicket, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'POST', bodyUptTicket)

    useEffect(() => {
        if(!loadingUptT){
            setDataUptTicket(serviceResponseUptT.data);
            setMessageUptTicket(serviceResponseUptT.message);
            setSuccessUptTicket(serviceResponseUptT.success);
            setRenderView(!renderView)
        }
    }, [loadingUptT, serviceResponseUptT, errorUptT])

    /* Usar boton respuesta */
    const [textoRes, setTextoRes] = useState(user.role == 7 ? '<p>Buenos días</p><br><br><br><p>Saludos</p>' : '');
    const [flagTextoRes, setFlagTextoRes] = useState(0)
    const [adjuntoRes, setAdjuntoRes] = useState([]) // [] de {nombreId: '', nombre: '', size: 0}
    const [flagAdjuntoRes, setFlagAdjuntoRes] = useState(0)

    const replyMessage = () => {
        flagAdjuntoRes === 0 && setFlagAdjuntoRes(1); // si el flag es 0 actualizo a 1 para indicar que empieza. Hata que no llega a 2 no ha acabado el proceso.

        if ((flagTextoRes === 0 || flagTextoRes === 2) && flagAdjuntoRes === 2)
        {
            setBodyUptTicket(JSON.stringify({
                Ticket: {
                    ...dataTicket,
                    estado: user.role == 7 ? "PROCESO" : "PENDIENTE",
                    mensaje: isFilled(textoRes) ? dataTicket.mensaje.concat({contenido: textoRes, usuarioId: user.idLogin}) : dataTicket.mensaje,
                    adjunto: isFilled(adjuntoRes) ? dataTicket.adjunto.concat(adjuntoRes.map((adjunto) => ({nombreId: adjunto.nombreId, nombre: adjunto.nombre, size: adjunto.size, usuarioId: user.idLogin}))) : dataTicket.adjunto
                }
            }))

            setTextoRes("")
            setAdjuntoRes([])

            setFlagAdjuntoRes(0);
            setFlagTextoRes(0);
        }
    }

    useEffect(() => {
        if((flagAdjuntoRes === 1 || flagAdjuntoRes === 2)) { replyMessage() }
    }, [flagAdjuntoRes, flagTextoRes]);

    const reopenTicket = () => {
        setBodyUptTicket(JSON.stringify({
            Ticket: {
                ...dataTicket,
                estado: "PROCESO"
            }
        }))
    }

    return(
        <div className = 'container-fluid ticketDetailPage' style={{minHeight: 'calc(100vh - 155px)'}}>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successTicket && !loadingGetT} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al obtener el detalle del ticket. Mensaje API: " + messageTicket}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successUptTicket && !loadingUptT && isFilled(messageUptTicket)} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al actualizar el ticket. Mensaje API: " + messageUptTicket}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={successUptTicket && !loadingUptT} onClose={() => {setSuccessUptTicket(false)}}>
                <Alert severity="success" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Ticket actualizado"}
                </Alert>
            </Snackbar>
            {loadingGetT
            ?
                <LoadingScreen text="Cargando..." className="ticketDetailLoading" />
            :isFilled(dataTicket) && !loadingGetT
            ?
                <>
                    <OpenConfirmDialog openConfirm = {openConfirm} setOpenConfirm = {setOpenConfirm} ticket = {dataTicket} setBodyUptTicket = {setBodyUptTicket} textoRes = {textoRes} adjuntoRes = {adjuntoRes} user = {user}/>
                    <div className = 'row' style = {{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <div className = 'd-inline-flex flex-row'>
                            <h5 style = {{marginTop: "5px", cursor: "pointer"}} onClick = {() => navigate('/soporte')}>Gestión de Tickets</h5>
                            <h5 style = {{marginTop: "5px"}}>&nbsp;-&nbsp;</h5>
                            <h5 style = {{marginTop: "5px", fontWeight: "500"}}>Detalle Ticket</h5>
                            {dataTicket.estado == "CERRADO" 
                            ? <button type="button" className='btn btn-outline-primary' style={{marginLeft: "auto"}} data-bs-toggle="tooltip" data-bs-placement="top" title="Reanudar la conversación" onClick={() => reopenTicket()}>Reabrir</button>
                            : <button type = "button" className = 'btn btn-outline-danger' data-bs-toggle="tooltip" data-bs-placement="top" title="Finalizar la conversación" style={{display: (user.idLogin == dataTicket.usuarioId || user.role == 7) && (dataTicket.estado == 'PENDIENTE' || dataTicket.estado == 'PROCESO') ? '' : 'none', marginLeft: "auto"}} onClick={() => setOpenConfirm(true)}><FaArchive/>  Cerrar ticket</button>}
                        </div>
                        <div className = 'col d-inline-flex justify-content-center'></div>
                    </div>
                    <hr size = "4px"/>
                    <div style = {{margin: "10px 10px"}}>
                        <TicketInfo user = {user} usersSAT = {usersSAT} ticket = {dataTicket} setTicket = {setDataTicket} textoRes = {textoRes} setTextoRes = {setTextoRes} adjuntoRes = {adjuntoRes} setAdjuntoRes = {setAdjuntoRes} flagAdjuntoRes={flagAdjuntoRes} setFlagAdjuntoRes={setFlagAdjuntoRes} setFlagTextoRes={setFlagTextoRes} setBodyUptTicket = {setBodyUptTicket}/>
                    </div>
                    <div className = 'row' style = {{display: "flex", justifyContent: "end", alignItems: "center"}}>
                        <div className = 'col-9 d-flex justify-content-end' style = {{marginRight: "10px", paddingLeft: "40px"}}>
                                    <button type = "button" className = 'btn btn-outline-success' data-bs-toggle="tooltip" data-bs-placement="top" title="Enviar contestación" style={{display: dataTicket.estado == 'PENDIENTE' || dataTicket.estado == 'PROCESO' ? '' : 'none'}} onClick={() => replyMessage()}><FaReply/>  Responder ticket</button>
                        </div>
                    </div>
                    
                </>
            :!isFilled(dataTicket) && !loadingGetT
            ?
                <div></div>
                
            :!successTicket && !loadingGetT
            ?
                <div>
                    <p>{`No es posible obtener la info del ticket. Mensaje: ${messageTicket}`}</p>
                </div>
            :   
                <div></div>
            }
        </div>
        
    );
}

export default TicketDetail;
